import React from 'react'
import { Card, Flex, Typography } from 'antd'
import {
  CTable,
  CModal,
  CButton,
  CModalTitle,
  CModalHeader,
} from '@coreui/react-pro'

const columns = [
  {
    key: 'status',
    label: 'Status',
  },
  {
    key: 'date',
    label: 'Date',
  },
  {
    key: 'time',
    label: 'Time',
  },
]

type Props = {
  isOpen: boolean
  onClose: () => void
  data: {
    status: string
    date: string
    time: string
  }[]
}

export const GatewaysDetailsHistoryModal: React.FC<Props> = ({
  data,
  isOpen,
  onClose,
}) => {
  return (
    <CModal visible={isOpen} onClose={onClose}>
      <Card>
        <Flex vertical>
          <CModalHeader style={{ borderBottom: 'none', padding: 0 }}>
            <Typography.Title style={{ margin: 0 }} level={4}>
              Connection history
            </Typography.Title>
          </CModalHeader>
          <CTable striped columns={columns} items={data}></CTable>
        </Flex>
      </Card>
    </CModal>
  )
}
